module.exports = __webpack_public_path__ + "img/18.25a3c50d.jpg";